<button mat-flat-button
        [ngClass]="buttonClasses"
        [ngStyle]="overrideStyles"
        [disabled]="disabled"
        [type]="buttonType"
        [matMenuTriggerFor]="menuTrigger"
        (click)="onClick($event)">
    @if (showLoader) {
        <img class="cs-loader-button"
             [src]="loaderSvgSrc">
    } @else {
        <cs-icon [csIcon]="csIcon"
                 [icon]="icon"/>
        <span>{{label}}</span>
    }
</button>
